import React from 'react';
import { Form, Label } from 'reactstrap';
import { Field, Fields } from 'redux-form';
import { compact } from 'underscore';

import PriceFilter from '../../../components/form/filter/price-filter';
import BedFilter from '../../../components/form/filter/bed-filter';
import BathFilter from '../../../components/form/filter/bath-filter';
import YearFilter from '../../../components/form/filter/year-filter';
import LocationTypeAhead from '../../../components/form/field/location-typeahead';
import BuildingTypeFilter from '../../../components/form/filter/building-type-filter';
import WaterfrontTypeFilter from '../../../components/form/filter/waterfront-type-filter';
import CommunityTypeFilter from '../../../components/form/filter/community-type-filter';
import DateRangeFilter from '../../../components/form/filter/daterange-filter';
import UncontrolledFormGroupCollapse from '../../../components/form/uncontrolled-form-group-collapse';

import BS from '../../../theme/Bootstrap';
import formStyles from '../../../components/form/form.module.scss';

let CommercialSearchModal = props => {
  const { handleSubmit } = props;

  return (
    <Form className={`${BS.alignItemsStart}`} onSubmit={handleSubmit}>
      <UncontrolledFormGroupCollapse>
        <Label for="address">Address, City, Neighborhood, Zip:</Label>
        <Field
          name="address"
          type="text"
          placeholder="Address, City, Neighborhood, Zip"
          component={LocationTypeAhead}
        />
      </UncontrolledFormGroupCollapse>
      <hr />
      <UncontrolledFormGroupCollapse className={formStyles.inputTextCenter}>
        <Label for="minPrice">Price:</Label>
        <Fields names={['minPrice', 'maxPrice']} component={PriceFilter} />
      </UncontrolledFormGroupCollapse>
      <hr />
      <UncontrolledFormGroupCollapse className={formStyles.inputTextCenter}>
        <Label for="minBed">Bedrooms:</Label>
        <Fields
          names={['minBed', 'maxBed']}
          showSuggestions
          asInput
          component={BedFilter}
        />
      </UncontrolledFormGroupCollapse>
      <hr />
      <UncontrolledFormGroupCollapse className={formStyles.inputTextCenter}>
        <Label for="minBath">Bathrooms:</Label>
        <Fields names={['minBed', 'maxBed']} showSuggestions component={BathFilter} />
      </UncontrolledFormGroupCollapse>
      <hr />
      <UncontrolledFormGroupCollapse>
        <Label for="buildingType">Building Type:</Label>
        <Field
          name="buildingType"
          numCols={2}
          numInnerCols={1}
          format={value => {
            return compact((value || '').trim().split(','));
          }}
          normalize={value => {
            return value.join(',');
          }}
          component={BuildingTypeFilter}
        />
      </UncontrolledFormGroupCollapse>
      <hr />
      <UncontrolledFormGroupCollapse className={formStyles.inputTextCenter}>
        <Label for="minYear">Year Built:</Label>
        <Fields names={['minYear', 'maxYear']} component={YearFilter} />
      </UncontrolledFormGroupCollapse>
      <hr />
      <UncontrolledFormGroupCollapse className={formStyles.inputTextCenter}>
        <Label for="ohStartDate">Open House Date Range:</Label>
        <Fields
          names={['ohStartDate', 'ohEndDate']}
          labels={['Start Date', 'End Date']}
          component={DateRangeFilter}
        />
      </UncontrolledFormGroupCollapse>
      <hr />
      <UncontrolledFormGroupCollapse>
        <Label for="communityType">Community Type:</Label>
        <Field
          name="communityType"
          numCols={2}
          numInnerCols={1}
          format={value => {
            return compact((value || '').trim().split(','));
          }}
          normalize={value => {
            return value.join(',');
          }}
          component={CommunityTypeFilter}
        />
      </UncontrolledFormGroupCollapse>
      <hr />
      <UncontrolledFormGroupCollapse>
        <Label for="waterfrontDescription">Waterfront Description:</Label>
        <Field
          name="waterfront"
          numCols={2}
          numInnerCols={1}
          format={value => {
            return compact((value || '').trim().split(','));
          }}
          normalize={value => {
            return value.join(',');
          }}
          component={WaterfrontTypeFilter}
        />
      </UncontrolledFormGroupCollapse>
    </Form>
  );
};

export default CommercialSearchModal;



// WEBPACK FOOTER //
// ./src/containers/PropertySearch/SearchModal/CommercialSearchModal.js